// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pIE8AnJU0UAEDo {
  width: 100%;
  min-width: 288px;
  max-width: 825px;
  margin-right: 16px;
}
.Xz4Vuev5TuVNSL {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 40px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"storyContainer": `pIE8AnJU0UAEDo`,
	"spinner": `Xz4Vuev5TuVNSL`
};
export default ___CSS_LOADER_EXPORT___;
